var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar3Day(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "18px",
    viewBox: "0 0 24 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "B62F94A6-02BB-48DF-9219-659F9407C631") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "KIT",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elementler-KIT",
    transform: "translate(-259.000000, -4878.000000)",
    fill: "#464646",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M280.75,4878 C281.716498,4878 282.5,4878.7835 282.5,4879.75 L282.5,4879.75 L282.5,4893.75 C282.5,4894.7165 281.716498,4895.5 280.75,4895.5 L280.75,4895.5 L260.75,4895.5 C259.783502,4895.5 259,4894.7165 259,4893.75 L259,4893.75 L259,4879.75 C259,4878.7835 259.783502,4878 260.75,4878 L260.75,4878 Z M265.87,4879.5 L260.75,4879.5 C260.611929,4879.5 260.5,4879.61193 260.5,4879.75 L260.5,4879.75 L260.5,4893.75 C260.5,4893.88807 260.611929,4894 260.75,4894 L260.75,4894 L265.906332,4894.00106 C265.882693,4893.9215 265.87,4893.83723 265.87,4893.75 L265.87,4879.5 Z M273.87,4879.5 L267.629953,4879.50083 L267.629953,4879.50083 L267.63,4893.75 C267.63,4893.83723 267.617307,4893.9215 267.593668,4894.00106 L273.906332,4894.00106 C273.882693,4893.9215 273.87,4893.83723 273.87,4893.75 L273.87,4879.5 Z M280.75,4879.5 L275.629953,4879.50083 C275.629984,4879.50389 275.63,4879.50694 275.63,4879.51 L275.63,4893.75 C275.63,4893.83723 275.617307,4893.9215 275.593668,4894.00106 L280.75,4894 C280.888071,4894 281,4893.88807 281,4893.75 L281,4893.75 L281,4879.75 C281,4879.61193 280.888071,4879.5 280.75,4879.5 L280.75,4879.5 Z",
    id: "3day"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar3Day);
export default __webpack_public_path__ + "static/media/Calendar3Day.14c2e8118a323f642a259b17d0039b49.svg";
export { ForwardRef as ReactComponent };